import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import AllEntities from "./AllEntities/AllEntities";

import PageContainer from "components/PageContainer/index.js";
import Footer from "examples/Footer/index.js";
import { Route, Routes } from "react-router-dom";

import AccessDenied from "components/AccessDenied/index.js";
import { useAuth } from "contexts/auth.context";

function Entities() {
  const { checkPermission } = useAuth();

  if (
    Object.keys(checkPermission("category")).filter(
      (key) => checkPermission("category")[key],
    ).length === 0
  ) {
    return <AccessDenied type="page" />;
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <PageContainer>
        <Routes>
          <Route
            index
            element={<AllEntities permissions={checkPermission("category")} />}
          />
        </Routes>
      </PageContainer>

      <Footer />
    </DashboardLayout>
  );
}

export default Entities;
